export const SITE_URL = typeof window !== 'undefined' ? window.location.origin : ''

export const HOME_SEO = {
  title: 'Lighter',
  description:
    'Lighter is an Ethereum L2 perpetual exchange with custom ZK circuits. Match and liquidate with proofs, low latency, and retail-zero fees.',
  canonical: '/',
}

export const TRADE_SEO = {
  title: 'Lighter — Perpetual Trading',
  description:
    'Trade LIT and other markets on Lighter with an order book, chart, and wallet-ready ticket.',
}

export const PORTFOLIO_SEO = {
  title: 'Portfolio — Lighter',
  description:
    'Review equity, performance, and positions on Lighter. Connect a wallet to load balances, PnL, and account history.',
  canonical: '/portfolio',
}

export const PUBLIC_POOLS_SEO = {
  title: 'Public Pools — Lighter',
  description:
    'Deposit into protocol or community-managed liquidity pools on Lighter and earn a share of their performance.',
  canonical: '/public-pools',
}

export const REFERRALS_SEO = {
  title: 'Referrals — Lighter',
  description:
    'Invite traders and earn up to 30% of the fees they pay, settled in USDC every Monday.',
  canonical: '/referrals',
}

export const SUB_ACCOUNTS_SEO = {
  title: 'Sub-Accounts — Lighter',
  description:
    'Organize your capital across separate trading accounts with isolated risk.',
  canonical: '/sub-accounts',
}

export const FUNDING_MARKET_RISK_SEO = {
  title: 'Funding & Market Risk Parameters — Lighter',
  description:
    'View funding rates, leverage limits, margin requirements, and other risk parameters for every market.',
  canonical: '/funding-market-risk-parameters',
}
